import { useParams } from 'react-router-dom';
import { get } from '@submize/lodash';
import { useGetFormQuery } from '../../Services/apiSlice';

const getCols = (schema, prefix = '') => {
  if (!schema) return [];
  const cols = [];

  Object.entries(schema.keys || []).forEach(([key, value]) => {
    if (value.type === 'object') {
      cols.push(...getCols(value, `${prefix + key}.`));
    } else {
      cols.push({
        path: prefix + key,
        label: get(value, 'flags.label', prefix + key),
      });
    }
  });

  return cols;
};

const useFormColumns = () => {
  const { formId } = useParams();
  const { data: form, isFetching } = useGetFormQuery(formId);
  if (isFetching) return [];
  return getCols(form.schema?.schema);
};

export default useFormColumns;
